import {Component, Input, OnChanges} from '@angular/core';


@Component({
	selector: 'password-strength-bar',
	templateUrl: './password-strength-bar.component.html',
	styleUrl: './password-strength-bar.component.scss',
})
export class PasswordStrengthBarComponent implements OnChanges {

	readonly rules = [
		{test: pw => pw.length >= 8},
		{test: pw => /[A-Z]/.test(pw)},
		{test: pw => /[a-z]/.test(pw)},
		{test: pw => /[0-9]/.test(pw)},
		{test: pw => /[^A-Za-z0-9]/.test(pw)}
	];

	readonly barColors = [
		{color: 'transparent'},
		{color: '#DD2C00'},
		{color: '#FF6D00'},
		{color: '#FFD600'},
		{color: '#AEEA00'},
		{color: '#00C853'},
	];

	@Input() password = '';

	score = 0;
	ruleResults: { passed: boolean }[] = [];

	get level() {
		return this.barColors[this.score];
	}

	ngOnChanges(): void {
		this.ruleResults = this.rules.map(rule => ({
			passed: rule.test(this.password),
		}));
		const passed = this.ruleResults.filter(r => r.passed).length;
		this.score = this.password ? Math.max(1, passed) : 0;
	}
}
